import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { keyboardDisplayed } from './keyboardDisplayed';
import { optionsDisplayed } from './optionsDisplayed';

export const inputActions = [keyboardDisplayed, optionsDisplayed];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
